module.exports = __webpack_public_path__ + "static/media/VAS_FEEDBACK_3.30a1278d.svg";